import React, { useEffect, useLayoutEffect, useRef, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import LayoutWrapper from "@iso/components/utility/layoutWrapper.js";
import Box from "@iso/components/utility/box";
import IntlMessages from "@iso/components/utility/intlMessages";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Dropdown,
  Input,
  Menu,
  Pagination,
  Popconfirm,
  Select,
  message,
  Spin
} from "antd";
import PropertyManagePage from "./Property.styles";
import {
  PlusOutlined,
  EllipsisOutlined,
  FileTextOutlined,
  SearchOutlined,
  CloseCircleOutlined,
  UpCircleOutlined,
  EditOutlined,
  CheckCircleOutlined,
  UserOutlined,
  QuestionCircleOutlined,
  EyeOutlined,
  PlusCircleOutlined,
  SettingOutlined,
  FundViewOutlined,
  CalendarOutlined,
  SafetyOutlined,
  ClockCircleOutlined,
  QrcodeOutlined,
} from "@ant-design/icons";
import propertyActions from "@iso/redux/property/actions";
import PropertyModal from "./PropertyModal";
import SelectPropertyModal from "./SelectPropertyModal";
import PropertyTableFirstCell from "./PropertyTableFirstCell";
import _, { property, slice } from "lodash";
import Table from "@iso/components/collapsing-table/table";
import { propertyService, permissionService } from "@iso/services";
import SubscriptionModal from "./SubscriptionModal";
import { subscriptionPlan } from "@iso/constants/subscriptionPlan";
import FormModal from "@iso/containers/Pages/Form/FormModal";
import PropertyHistoryModal from "./PropertyHistoryModal";
import ImportModal from "./ImportModal";
import OptiWeightModal from "./OptiWeightModal";
import IotDeviceModal from "./IotDeviceModal";
import HideShowModulesModal from "./HideShowModulesModal";
import PropertyQrModal from "./PropertyQrModal";
import Loader from "../../../components/utility/loader";
import "./ManageProperty.css";
import WelcomeModal from ".././../../components/WelcomeModal/WelcomeModal";
import { propertyHelper } from "@iso/lib/helpers/propertyHelper";
import { commonHelper } from "@iso/lib/helpers/commonHelper";
import { LoadingOutlined } from "@ant-design/icons";
const { changeActiveProperty } = propertyActions;

const Property = (props) => {
  let history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const activePropertyId = useSelector(
    (state) => state.property.activePropertyId
  );
  const activePropertySubscription = useSelector(
    (state) => state.property.activePropertySubscription
  );
  const activePermission = useSelector((state) => state.permission);
  const [visible, setVisiblity] = React.useState(false);
  const activeProperty = commonHelper.getActiveProperty();
  const [editProperty, setEditProperty] = React.useState({});
  const [property, setProperty] = React.useState({});
  const { Option } = Select;
  const [properties, setProperties] = React.useState([]);
  const [isSaved, setIsSaved] = React.useState(false);
  const [visibleSelectProperty, setVisiblitySelectProperty] =
    React.useState(false);
  const [visibleFormModal, setVisiblityFormModal] = React.useState(false);
  const [visibleHistoryModal, setVisiblityHistoryModal] = React.useState(false);
  const [propertyHistory, setPropertyHistory] = React.useState({});
  const [visibleImportModal, setVisibleImportModal] = React.useState(false);
  const [visibleOptiWeight, setVisibleOptiWeight] = React.useState(false);
  const [visibleIotDevice, setVisibleIotDevice] = React.useState(false);
  const [visibleWelcomeModal, setVisibleWelcomeModal] = React.useState(false);
  const [visibleUpgradeModal, setVisibleUpgradeModal] = React.useState(false);
  const [visibleHideShowModules, setVisibleHideShowModules] = React.useState(false);
  const [visiblePropertyQrModal, setVisiblePropertyQrModal] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isInitialLoad, setIsInitialLoad] = React.useState(true);
  const [pageSize, setPageSize] = React.useState(10);
  const [searchInput, setsearchInput] = React.useState("");
  const [loadingData, setLoadingData] = React.useState(true);
  const [propertyData, setPropertyData] = React.useState([]);
  const [debouncedSearch, setDebouncedSearch] = React.useState("");
  const [allProperties, setAllProperties] = React.useState([]);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const displayedProperties = searchQuery?.slice(startIndex, endIndex);
  const displayData =
    props.search_result &&
    props.search_result.Property?.slice(startIndex, endIndex);

  const welcomeDismissed = useSelector((state) => state.property.welcomeDismissed);
  const selectedPropertyModalDismissed = useSelector((state) => state.property.selectedPrpertyModalDismissed);
  const restoringProperty = useSelector((state) => state.property.restoringProperty);
  const [loadingOptions,setLoadingOpions] = React.useState(false);
  const [hasMore, setHasMore] = React.useState(false);
  const [pageOptions, setPageOptions] = React.useState(1);
  const handlePageSizeChange = (current, size) => {
    setCurrentPage(1);
    setPageSize(size);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchInput.trim()), 400);
    return () => clearTimeout(t);
  }, [searchInput]);

  

  useEffect(() => {    
    getPropertyList();
  }, [activePropertyId, isSaved, activePropertySubscription,currentPage,pageSize,debouncedSearch]);

  useEffect(() => {
    getOptionPropertyList(1);
  }, []);
  const optionReqIdRef = useRef(0);

  const getOptionPropertyList = (pageArg = 1) => {
    if (loadingOptions || (!hasMore && pageArg !== 1)) return;

    setLoadingOpions(true);
    const myReq = ++optionReqIdRef.current;

    return propertyService.getOptionProperty(pageArg)
      .then((res) => {
        if (myReq !== optionReqIdRef.current) return;

        const list = res?.properties?.data ?? res?.properties ?? [];

        setAllProperties((prev) =>
          pageArg === 1 ? list : [...prev, ...list.filter(p => !prev.some(x => x.id === p.id))]
        );
        const totalPage = res?.properties?.total_page;
        const more = totalPage ? pageArg < totalPage : list.length > 0;
        setHasMore(more);
        if (more) setPageOptions(pageArg + 1);
      })
      .finally(() => setLoadingOpions(false));
  };

  const handlePopupScroll = useCallback((e) => {
    const t = e.target;
    const nearBottom = t.scrollTop + t.clientHeight >= t.scrollHeight - 100; 

    if (nearBottom && hasMore && !loadingOptions) {
      getOptionPropertyList(pageOptions); // load more
    }
  }, [hasMore, loadingOptions, pageOptions]);

  const reqIdRef = useRef(0);
  const getPropertyList = (opts = {}) => {
    const {
      is_paginated = true,
      page = currentPage,
      size = pageSize,
      q = debouncedSearch,
    } = opts;

    const normQ = (q ?? "").trim();

    const reqId = ++reqIdRef.current;
    setLoadingData(true);

    return propertyService
      .getProperties(is_paginated, page, size, normQ)
      .then((res) => {
        // Ignore old requests
        if (reqId !== reqIdRef.current) return { ignored: true, list: [], raw: null };

        const list = res?.properties?.data || [];

        if (list.length === 0) {
          // reset states
          setProperties([]);
          setSearchQuery([]);
          setPropertyData([]);

          // show modal if no search input
          // The onboarding wizard already covers "you have no properties"; the
          // older notice is only for a user who has dismissed the wizard. Opening
          // both left the notice behind the wizard, and closing it after
          // onboarding (with VerifyPage's state.visible) opened the legacy
          // create-property form on top of a property just created.
          if (!normQ) {
            if (!welcomeDismissed) setVisibleWelcomeModal(true);
            else if (!selectedPropertyModalDismissed) setVisiblitySelectProperty(true);
          }

          return { ignored: false, list: [], raw: res?.properties ?? null };
        }

        // set data
        setProperties(list);
        setSearchQuery(list);
        setPropertyData(res?.properties || []);

        // auto-select active property
        if (list.length === 1 && !normQ) {
          localStorage.setItem("active_property", JSON.stringify(list[0]));
          dispatch(changeActiveProperty(list[0]));
          setVisiblitySelectProperty(false);
        } else if (!activeProperty && !activePropertyId && !selectedPropertyModalDismissed && !restoringProperty) {
          setVisiblitySelectProperty(true);
        }

        return { ignored: false, list, raw: res?.properties ?? null };
      })
      .catch((err) => {
        console.error("Error loading properties:", err);
        return { ignored: false, list: [], raw: null, error: err };
      })
      .finally(() => {
        if (reqId === reqIdRef.current) setLoadingData(false);
      });
  };
  
  useEffect(() => {
    if (props?.handlePropertyLength) {
      props?.handlePropertyLength(properties.length);
    }
  }, [properties]);

  const handleMenuClick = (property, e) => {
    if (e.key === "editStatus") {
      localStorage.setItem("active_property", JSON.stringify(property));
      // changeActiveProperty persists the active property to the backend.
      dispatch(changeActiveProperty(property));
    }
    if (e.key === "userAccess") {
      localStorage.setItem('active_property', JSON.stringify(property));
      dispatch(changeActiveProperty(property));
      history.push('/user-access');
    }

    if (e.key === "upgrade") {
      setProperty(property);
      setVisibleUpgradeModal(true);
    }

    if (e.key == "import") {
      showImportModal();
      setProperty(property);
    }
    if (e.key == "optiWeight") {
      setProperty(property);
      setVisibleOptiWeight(true);
    }
    if (e.key == "iotDevice") {
      setProperty(property);
      setVisibleIotDevice(true);
    }
    if (e.key == "manageSubscription") {
      propertyService.getStripePortalUrl(property.id).then((res) => {
        if (res.code === "0000") {
          window.open(res.url, "_blank");
        } else {
          message.error(res.message);
        }
      });
    }
    if (e.key === "hideShowModules") {
      setProperty(property);
      setVisibleHideShowModules(true);
    }
  };

  const showModal = () => {
    setVisiblity(true);
  };

  const cancelModal = () => {
    setVisiblity(false);
    setEditProperty({});
  };

  const cancelSelectPropertyModal = () => {
    setVisiblitySelectProperty(false);
     dispatch(propertyActions.setSelectedPropertyModalDismissed());
    if (location.state?.visible) {
      setVisiblity(true);
    }
  };

  const cancelWelcomeModal = () => {
    setVisibleWelcomeModal(false);
    dispatch(propertyActions.setWelcomeDismissed());
  }


  const cancelUpgradeModal = () => {
    setVisibleUpgradeModal(false);
    setProperty({});
  };

  const showHistory = (property) => {
    setPropertyHistory(property);
    setVisiblityHistoryModal(true);
  };

  const cancelHistory = () => {
    setPropertyHistory({});
    setVisiblityHistoryModal(false);
  };
  const menuList = (property, permission) => (
    <Menu onClick={handleMenu.bind(this, property)}>
      {(permission == "owner" || permission == "admin") && (
        <Menu.Item key="editDetails" icon={<EditOutlined />}>
          <IntlMessages id="propertyPage.managePage.editDetails" />
        </Menu.Item>
      )}
      <Menu.Item key="propertyQr" icon={<QrcodeOutlined />}>
        Property QR Code
      </Menu.Item>
      <Menu.Item key="history" icon={<FileTextOutlined />}>
        <IntlMessages id="History" />
      </Menu.Item>
      {(permission == "owner" || permission == "admin") && (
        <Menu.Item key="userAccess" icon={<UserOutlined />}>
          <IntlMessages id="propertyPage.managePage.userAccess" />
        </Menu.Item>
      )}
      {permission == "owner" && (
        <Menu.Item key="addForm" icon={<PlusCircleOutlined />}>
          <IntlMessages id="Add Form" />
        </Menu.Item>
      )}
      <Menu.Item key="viewForm" icon={<EyeOutlined />}>
        <IntlMessages id="View Form" />
      </Menu.Item>
      {permission == "owner" && (
        <Menu.Item key="upgrade" icon={<UpCircleOutlined />}>
          <IntlMessages id="propertyPage.managePage.upgrade" />
        </Menu.Item>
      )}
      <Menu.Item key="viewTiers" icon={<QuestionCircleOutlined />}>
        <IntlMessages id="propertyPage.managePage.viewTiers" />
      </Menu.Item>

      {activePropertyId != property.id && (
        <Menu.Item key="editStatus" icon={<CheckCircleOutlined />}>
          <IntlMessages id="propertyPage.managePage.active" />
        </Menu.Item>
      )}
      {propertyHelper.checkIsGoldPackage(property.subscription_label) && (
        <Menu.Item key="import" icon={<PlusOutlined />}>
          <IntlMessages id="mobPage.managePage.import" />
        </Menu.Item>
      )}
      {propertyHelper.checkIsGoldPackage(property.subscription_label) && (
        <Menu.Item key="optiWeight" icon={<SettingOutlined />}>
          <IntlMessages id="antTable.optiWeight" />
        </Menu.Item>
      )}
      {propertyHelper.checkIsGoldPackage(property.subscription_label) && (
        <Menu.Item key="iotDevice" icon={<SettingOutlined />}>
          <IntlMessages id="antTable.iotDevice" />
        </Menu.Item>
      )}
      {(permission == "owner" || permission == "admin") && (
        <Menu.Item key="propertySettings" icon={<ClockCircleOutlined />}>
          Property Settings
        </Menu.Item>
      )}
      {(permission == "owner" || permission == "admin") && (
        <Menu.Item key="holidayManagement" icon={<CalendarOutlined />}>
          Holiday Calendar
        </Menu.Item>
      )}
      {(permission == "owner" || permission == "admin") && (
        <Menu.Item key="roleAssignment" icon={<SafetyOutlined />}>
          Safety Roles
        </Menu.Item>
      )}
      {property.stripe_id && (
        <Menu.Item key="manageSubscription" icon={<FundViewOutlined />}>
          <IntlMessages id="antTable.manageSubscription" />
        </Menu.Item>
      )}
      {propertyHelper.checkIsGoldPackage(property.subscription_label) && (
        <Menu.Item key="hideShowModules" icon={<SettingOutlined />}>
          Hide/Show Modules
        </Menu.Item>
      )}
    </Menu>
  );
  const handleMenu = (property, e) => {
    if (e.key === "viewDetails") {
    }
    if (e.key === "history") {
      setPropertyHistory(property);
      setVisiblityHistoryModal(true);
    }
    if (e.key === "editDetails") {
      setVisiblity(true);
      setEditProperty(property);
    }
    if (e.key === "propertyQr") {
      setProperty(property);
      setVisiblePropertyQrModal(true);
    }
    if (e.key === "userAccess") {
      localStorage.setItem('active_property', JSON.stringify(property));
      dispatch(changeActiveProperty(property));
      history.push('/user-access');
    }
    if(e.key === 'viewForm') {
      localStorage.setItem('active_property', JSON.stringify(property));
      dispatch(changeActiveProperty(property));
      history.push('/manage-forms');
    }

    if (e.key === "addForm") {
      setProperty(property);
      setVisiblityFormModal(true);
    }
    if (e.key === "upgrade") {
      setProperty(property);
      setVisibleUpgradeModal(true);
    }
    if (e.key === "viewTiers") {
      window.open("https://www.airagri.com.au/subscription-pricing-plans/");
    }
    if (e.key === "editStatus") {
      localStorage.setItem("active_property", JSON.stringify(property));
      // changeActiveProperty persists the active property to the backend.
      dispatch(changeActiveProperty(property));
    }
    if (e.key === "userAccess") {
      localStorage.setItem('active_property', JSON.stringify(property));
      dispatch(changeActiveProperty(property));
      history.push('/user-access');
    }

    if (e.key === "upgrade") {
      setProperty(property);
      setVisibleUpgradeModal(true);
    }

    if (e.key == "import") {
      showImportModal();
      setProperty(property);
    }
    if (e.key == "optiWeight") {
      setProperty(property);
      setVisibleOptiWeight(true);
    }
    if (e.key == "iotDevice") {
      setProperty(property);
      setVisibleIotDevice(true);
    }
    if (e.key == "propertySettings") {
      localStorage.setItem('active_property', JSON.stringify(property));
      dispatch(changeActiveProperty(property));
      history.push('/property-settings');
    }
    if (e.key == "holidayManagement") {
      localStorage.setItem('active_property', JSON.stringify(property));
      dispatch(changeActiveProperty(property));
      history.push('/holiday-management');
    }
    if (e.key == "roleAssignment") {
      localStorage.setItem('active_property', JSON.stringify(property));
      dispatch(changeActiveProperty(property));
      history.push('/role-assignment');
    }
    if (e.key == "manageSubscription") {
      propertyService.getStripePortalUrl(property.id).then((res) => {
        if (res.code === "0000") {
          window.open(res.url, "_blank");
        } else {
          message.error(res.message);
        }
      });
    }
    if (e.key === "hideShowModules") {
      setProperty(property);
      setVisibleHideShowModules(true);
    }
  };
  const columns = [
    {
      label: <IntlMessages id="antTable.title.property" />,
      accessor: "name",
      minWidth: 100,
      sortable: true,
      position: 1,
      priorityLevel: 1,
      CustomComponent: (cell) => {
        return (
          <PropertyTableFirstCell
            activePropertyId={activePropertyId}
            property={cell.row}
          />
        );
      },
    },
    {
      label: <IntlMessages id="antTable.title.property_code" />,
      accessor: 'publish_code',
      minWidth: 100,
      sortable: true,
      position: 2,
      priorityLevel: 2,
    },
    {
      label: <IntlMessages id="antTable.title.address" />,
      accessor: "address",
      minWidth: 300,
      sortable: true,
      position: 2,
      priorityLevel: 2,
    },
    {
      label: <IntlMessages id="antTable.title.subscription_tier" />,
      accessor: "subscription_label",
      minWidth: 300,
      sortable: true,
      position: 3,
      priorityLevel: 3,
      CustomComponent: (cell) => {
        let row = cell.row;
        if (row.subscription_label) {
          return subscriptionPlan.map((value, index) => {
            if (value.value == row.subscription_label) {
              return <div key={index}>{value.label}</div>;
            }
          });
        } else {
          return (
            <div>
              {
                <IntlMessages id="subscription.prices.REACT_APP_STRIPE_PLAN_BRONZE" />
              }
            </div>
          );
        }
      },
    },
    {
      label: "",
      accessor: "dot-menu",
      minWidth: 100,
      sortable: true,
      position: 4,
      priorityLevel: 4,
      noTitle: true,
      CustomComponent: (cell) => {
        let property = cell.row;
        let permission = permissionService.getPermission(
          property.permission_id
        );
        return (
          <Dropdown
            overlay={menuList(property, permission)}
            trigger={["click"]}
          >
            <div
              className="property-area-dot-btn"
              style={{ cursor: "pointer" }}
            >
              <EllipsisOutlined className="dotIcon" />
            </div>
          </Dropdown>
        );
      },
    },
  ];

  const handleOptionClick = (value) => {
    if (activeProperty?.id === value) return;
    const selected = allProperties.find(p => p.id === value);
    if (selected) {
      localStorage.setItem('active_property', JSON.stringify(selected));
      dispatch(changeActiveProperty(selected));
    }
  };
  const menuRef = useRef(null);
  const greenIndicator = <LoadingOutlined style={{ fontSize: 16, color: "#0B2A1B" }} spin />;
  const renderOptionsProperty = () => {
    // No properties: nothing to list. The onboarding wizard rendered at the
    // bottom of the page handles this case.
    if (!properties || properties.length === 0) {
      return null;
    }

    let options = [];
    _.forEach(allProperties, (property, index) => {
      options.push(
        <Option key={index} value={property?.id} className="property-option">
          {property?.name}
        </Option>
      );
    });

    return (
      <Select
        placeholder="Select Active Property"
        value={activeProperty ? { value: activeProperty.id, label: activeProperty.name } : null}
        size="large"
        className="custSelect"
        onChange={handleOptionClick}
        onPopupScroll={handlePopupScroll} 
        dropdownRender={(menu) => (
        <div ref={menuRef} style={{ maxHeight: 320, overflow: 'auto' }}>
          {menu}
          <div className="dropdown-footer" style={{ textAlign: 'center', color: '#0B2A1B' }}>
            {loadingOptions ? <Spin size="small" indicator={greenIndicator} className="custom-spin"/> : null}
          </div>
        </div>
      )}
      >
        {options}
      </Select>
    );
  };

  const onSaved = () => {
    setIsSaved(!isSaved);
  };

  const cancelFormModal = () => {
    setVisiblityFormModal(false);
  };

  const showImportModal = () => {
    setVisibleImportModal(true);
  };

  const cancelImportModal = () => {
    setVisibleImportModal(false);
    setProperty({});
  };
  const cancelOptiWeight = () => {
    setVisibleOptiWeight(false);
    setProperty({});
  };
  const cancelIotDevice = () => {
    setVisibleIotDevice(false);
    setProperty({});
  };
  const cancelHideShowModules = () => {
    setVisibleHideShowModules(false);
    setProperty({});
  };
  const handleCancelSearch = () => {
    setsearchInput("");
    setCurrentPage(1);
  };
  const handleSearch = (e) => {
    setsearchInput(e.target.value); 
    setCurrentPage(1);
  };
  return (
    <LayoutWrapper>
      <PropertyManagePage>
        <Box id="containerBox">
          <div className="manage-property-header">
            <div className="mp-title">
              <h2 className="manage-property-title">Manage Properties</h2>
            </div>
            {props.search_result ? (
              ""
            ) : (
              <>
              <Input
              placeholder="Search…"
              suffix={
                !searchInput && (
                  <SearchOutlined className="site-form-item-icon" />
                )
              }
              prefix={
                searchInput && (
                  <CloseCircleOutlined
                    onClick={handleCancelSearch}
                    className="site-form-item-cancel"
                  />
                )
              }
              size="large"
              className="search-bar"
              value={searchInput}
              onChange={(e) => handleSearch(e)}
            />
            <div className="button-group" style={{ gap: "12px" }}>
             
              {renderOptionsProperty()}
              <Button
                icon={<PlusOutlined />}
                type="primary"
                className="cutAddButton"
                onClick={showModal}
                size="large"
                style={{
                  background: "#0B2A1B",
                  borderRadius: "8px !important",
                }}
              >
                <IntlMessages id="propertyPage.managePage.addProperty" />
              </Button>
            </div>
            </>)}
          </div>
          {loadingData ? (
            <Loader />
          ) : (
            <>
              {props.search_result &&
              props.search_result.Property &&
              props.search_result.Property.length > 0 ? (
                <>
                  <div className="manage-table">
                    <Table
                      columns={columns}
                      rows={displayData}
                      containerId="containerBox"
                      showPagination={false}
                      rowSize={99999}
                    />
                  </div>
                  {props.search_result.Property?.length > 10 && (
                    <div style={{ padding: "20px" }}>
                      <Pagination
                        current={currentPage}
                        total={props.search_result.Property?.length}
                        pageSize={pageSize}
                        onChange={handlePageChange}
                        showSizeChanger
                        pageSizeOptions={["10", "20", "50", "100"]}
                        onShowSizeChange={handlePageSizeChange}
                      />
                    </div>
                  )}
                </>
              ) : (
                <div className="manage-table">
                    <>
                      {!props.search_result &&
                      properties &&
                      properties.length > 0 ? (
                        <>
                          <Table
                            columns={columns}
                            rows={properties}
                            containerId="containerBox"
                            showPagination={false}
                            rowSize="99999"
                          />

                          <div style={{ padding: "20px" }}>
                            <Pagination
                              current={currentPage}
                              total={propertyData?.total_item || 0}
                              pageSize={pageSize}
                              onChange={handlePageChange}
                              showSizeChanger
                              pageSizeOptions={["10", "20", "50", "100"]}
                              onShowSizeChange={handlePageSizeChange}
                            />
                          </div>
                        </>
                      ) : (
                        <h1 style={{ padding: "15px 15px", color: "gray" }}>
                          <IntlMessages id="dashboardPage.noData" />
                        </h1>
                      )}
                    </>
                  
                </div>
              )}
            </>
          )}
        </Box>
        <PropertyModal
          editProperty={editProperty}
          visible={visible}
          cancelModal={cancelModal}
          onSaved={onSaved}
        />
        <SelectPropertyModal
          activeProperty={activeProperty}
          propertyPage={true}
          visibleSelectProperty={visibleSelectProperty}
          cancelSelectPropertyModal={cancelSelectPropertyModal}
        />
        { visibleUpgradeModal ? <SubscriptionModal
          visible={visibleUpgradeModal}
          property={property}
          cancelModal={cancelUpgradeModal}
          onSaved={onSaved}
        /> : null }
        <FormModal
          visibleFormModal={visibleFormModal}
          cancelModal={cancelFormModal}
          propertyId={property.id}
          fromProperty={true}
        />
        <PropertyHistoryModal
          visibleHistoryModal={visibleHistoryModal}
          cancelHistory={cancelHistory}
          propertyId={propertyHistory.id}
        />
        <ImportModal
          visibleImportModal={visibleImportModal}
          cancelImportModal={cancelImportModal}
          property={property}
        />
        <OptiWeightModal
          visibleOptiWeight={visibleOptiWeight}
          cancelOptiWeight={cancelOptiWeight}
          property={property}
        />
        <IotDeviceModal
          visibleIotDevice={visibleIotDevice}
          cancelIotDevice={cancelIotDevice}
          onSaved={onSaved}
          property={property}
        />
        <HideShowModulesModal
          visibleHideShowModules={visibleHideShowModules}
          cancelHideShowModules={cancelHideShowModules}
          onSaved={onSaved}
          property={property}
        />
        <PropertyQrModal
          visible={visiblePropertyQrModal}
          property={property}
          onCancel={() => {
            setVisiblePropertyQrModal(false);
            setProperty({});
          }}
        />
        <WelcomeModal
          visibleWelcomeModal={visibleWelcomeModal}
          cancelWelcomeModal={cancelWelcomeModal}
          getPropertyList={getPropertyList}
        ></WelcomeModal>
      </PropertyManagePage>
    </LayoutWrapper>
  );
};

export default Property;
